import { useTheme } from "@reactive-resume/hooks";
import { useEffect } from "react";

import { watchBrowserChrome } from "../utils/browser-chrome";

type Props = { children: React.ReactNode };

export const ThemeProvider = ({ children }: Props) => {
  const { isDarkMode } = useTheme();

  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
  }, [isDarkMode]);

  useEffect(() => watchBrowserChrome(), []);

  return children;
};
